import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep2_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F28.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame28() {
    let [isLoading, setIsLoading] = useState(false)
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);

    useEffect(() => {
        setTimeout(function () { setIsLoading(false) }, 100);

    }, [])

    if (isLoading === true) {
        return (<div className="F1_image"></div>)
    } else {
        return (
            <div className="F28_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F28_entryBox">
                    <div className="F28_paragraph">
                        {language === 'english' ?
                            <p className="F28_paragraphEnglish">In the break, Saira tells her teacher about the reason for being late. She is feeling low and terrified of what if periods had come during schooltime. She inquires her teacher in a dismay.</p>
                            :
                            <p className="F28_paragraphUrdu"> اسکول میں بریک کے دوران سائرہ اپنی ٹیچر کو لیٹ آنے کی وجہ بتاتی ہے۔ وہ یہ سوچ کر بہت خوفزدہ ہے کہ اگر یہ سب کچھ اس کےساتھ اسکول کے دوران ہوتا تو وہ کیا کرتی۔ وہ پریشانی میں اپنی ٹیچر سے پوچھتی ہے۔</p>
                        }
                    </div>

                    <div className="F28_timeline">
                        <div className='F28_timelineBar'>
                            <div className='F28_timelineFill'></div>
                            <span className='F28_timelineText'>5/19</span>
                        </div>
                    </div>

                    <div className="F28_nextFrames">
                        <div className="F28_nextFrame1"></div>
                        <div className="F28_nextFrame2"></div>
                        <div className="F28_nextFrame3"></div>
                    </div>

                    <div className='F28_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep2_lastVisitFrame(5)) }} className='F28_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
    }
}

export default Frame28;